import { useIntl } from 'react-intl'

type Props = {
  id: string
}

export const Products = ({ id }: Props) => {
  const { formatMessage } = useIntl()

  return (
    <section id={id} className="bg-[#DFEAF0]">
      <div className="text-start max-w-[1264px] mx-auto flex flex-col gap-12 xl:flex-row">
        <div className="md:flex md:flex-col mt-[100px] xl:mt-36 px-4 text-center xl:text-left xl:max-w-[256px]">
          <h2 className="text-2xl md:text-[36px] mb-4 uppercase font-openSans text-[#068A8A] font-bold">
            {formatMessage({ id: 'PRODUCTS' })}
          </h2>
          <p className="text-[#39393A] md:text-2xl text-xl md:leading-9 font-montserrat md:font-semibold">
            {formatMessage({ id: 'PRODUCTS_TEXT' })}
          </p>
        </div>

        <div className="grid w-full grid-cols-1 sm:grid-cols-2 md:grid-cols-3">
          <div className="flip-card group relative bg-[#FFB199] w-auto md:h-[400px] h-[320px] flex items-end px-4 pb-10">
            <div className="relative w-full h-full transition-transform group-hover:rotate-y-180 flip-card-inner preserve-3d">
              <div className="absolute flex items-end w-full h-full transition-transform bg-no-repeat bg-contain flip-card-front backface-invisible bg-front1">
                <h3 className="font-openSans text-xl md:text-2xl font-bold text-[#001D2F] leading-[48px]">
                  {formatMessage({ id: '1_1_MEETINGS' })}
                </h3>
              </div>

              <div className="absolute flex items-end w-full h-full backface-invisible rotate-y-180 flip-card-back">
                <div className="w-full">
                  <h3 className="font-openSans text-xl md:text-2xl font-bold mb-4 text-[#001D2F] leading-[48px]">
                    {formatMessage({ id: '1_1_MEETINGS' })}
                  </h3>
                  <p className="text-xs md:text-base font-medium leading-6 text-[#001D2F] font-montserrat">
                    {formatMessage({ id: '1_1_MEETINGS_TEXT' })}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="flip-card group relative bg-[#87E3E3] flex items-end px-4 pb-10 w-auto md:h-[400px] h-[320px]">
            <div className="relative w-full h-full transition-transform group-hover:rotate-y-180 flip-card-inner preserve-3d">
              <div className="absolute flex items-end w-full h-full transition-transform bg-no-repeat bg-contain flip-card-front backface-invisible bg-front2">
                <h3 className="font-openSans text-xl md:text-2xl font-bold text-[#001D2F] leading-[48px]">
                  {formatMessage({ id: 'IN_PERSON_PLACEMENTS' })}
                </h3>
              </div>

              <div className="absolute flex items-end w-full h-full backface-invisible rotate-y-180 flip-card-back">
                <div className="w-full">
                  <h3 className="font-openSans text-xl md:text-2xl font-bold mb-4 text-[#001D2F] leading-[48px]">
                    {formatMessage({ id: 'IN_PERSON_PLACEMENTS' })}
                  </h3>
                  <p className="text-xs md:text-base font-medium leading-6 text-[#001D2F] font-montserrat">
                    {formatMessage({ id: 'IN_PERSON_PLACEMENTS_TEXT' })}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="flip-card group relative bg-[#BEDAE9] px-4 pb-10 h-[320px] flex items-end w-auto md:h-[400px]">
            <div className="relative w-full h-full transition-transform group-hover:rotate-y-180 flip-card-inner preserve-3d">
              <div className="absolute flex items-end w-full h-full transition-transform bg-no-repeat bg-contain flip-card-front backface-invisible bg-front3">
                <h3 className="font-openSans text-xl md:text-2xl font-bold text-[#001D2F] leading-[48px]">
                  {formatMessage({ id: 'ROUNDTABLES' })}
                </h3>
              </div>

              <div className="absolute flex items-end w-full h-full backface-invisible rotate-y-180 flip-card-back">
                <div className="w-full">
                  <h3 className="font-openSans text-xl md:text-2xl font-bold mb-4 text-[#001D2F] leading-[48px]">
                    {formatMessage({ id: 'ROUNDTABLES' })}
                  </h3>
                  <p className="text-xs md:text-base font-medium leading-6 text-[#001D2F] font-montserrat">
                    {formatMessage({ id: 'ROUNDTABLES_TEXT' })}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="flip-card group relative bg-[#BEDAE9] px-4 pb-10 h-[320px] flex items-end w-auto md:h-[400px]">
            <div className="relative w-full h-full transition-transform group-hover:rotate-y-180 flip-card-inner preserve-3d">
              <div className="absolute flex items-end w-full h-full transition-transform bg-no-repeat bg-contain flip-card-front backface-invisible bg-front4">
                <h3 className="font-openSans text-xl md:text-2xl font-bold text-[#001D2F] leading-[48px]">
                  {formatMessage({ id: 'WORKSHOPS' })}
                </h3>
              </div>

              <div className="absolute flex items-end w-full h-full backface-invisible rotate-y-180 flip-card-back">
                <div className="w-full">
                  <h3 className="font-openSans text-xl md:text-2xl font-bold mb-4 text-[#001D2F]">
                    {formatMessage({ id: 'WORKSHOPS' })}
                  </h3>
                  <p className="text-xs md:text-base font-medium leading-6 text-[#001D2F] font-montserrat">
                    {formatMessage({ id: 'WORKSHOPS_TEXT' })}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="flip-card group relative bg-[#FFB199] px-4 pb-10 h-[320px] flex items-end w-auto md:h-[400px]">
            <div className="relative w-full h-full transition-transform group-hover:rotate-y-180 flip-card-inner preserve-3d">
              <div className="absolute flex items-end w-full h-full transition-transform bg-no-repeat bg-contain flip-card-front backface-invisible bg-front5">
                <h3 className="font-openSans text-xl md:text-2xl font-bold text-[#001D2F] leading-[48px]">
                  {formatMessage({ id: 'CONSULTING_PROJECTS' })}
                </h3>
              </div>

              <div className="absolute flex items-end w-full h-full backface-invisible rotate-y-180 flip-card-back">
                <div className="w-full">
                  <h3 className="font-openSans text-xl md:text-2xl font-bold text-[#001D2F] leading-[48px] mb-4">
                    {formatMessage({ id: 'CONSULTING_PROJECTS' })}
                  </h3>
                  <p className="text-xs md:text-base font-medium leading-6 text-[#001D2F] font-montserrat">
                    {formatMessage({ id: 'CONSULTING_PROJECTS_TEXT' })}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="flip-card group relative bg-[#87E3E3] px-4 pb-10 h-[320px] flex items-end w-auto md:h-[400px]">
            <div className="relative w-full h-full transition-transform group-hover:rotate-y-180 flip-card-inner preserve-3d">
              <div className="absolute flex items-end w-full h-full transition-transform bg-no-repeat bg-contain flip-card-front backface-invisible bg-front6">
                <h3 className="font-openSans text-xl md:text-2xl font-bold text-[#001D2F] leading-[48px]">
                  {formatMessage({ id: 'GUIDED_DISCUSSIONS' })}
                </h3>
              </div>

              <div className="absolute flex items-end w-full h-full backface-invisible rotate-y-180 flip-card-back">
                <div className="w-full">
                  <h3 className="font-openSans text-xl md:text-2xl font-bold mb-4 text-[#001D2F] leading-[48px]">
                    {formatMessage({ id: 'GUIDED_DISCUSSIONS' })}
                  </h3>
                  <p className="text-xs md:text-base font-medium leading-6 text-[#001D2F] font-montserrat">
                    {formatMessage({ id: 'GUIDED_DISCUSSIONS_TEXT' })}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

//
